import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { DeleteWithConfirmButton, SaveButton, Toolbar } from 'react-admin';
import { SubsectionRecord } from '../interfaces/subsection-record.interface';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const SubsectionEditToolbar = (props: { record?: SubsectionRecord }) => {
  const { record } = props;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton />
      <DeleteWithConfirmButton
        undoable={false}
        redirect={`/section/${record?.sectionId ?? ''}`}
        confirmTitle="messages.subsection.deleteConfirmTitle"
        confirmContent="messages.subsection.deleteConfirmContent"
      />
    </Toolbar>
  );
};
